<template>
	<div>
		<div class="printHide">
			<div class="d-none d-md-block">
				<nav-header :navText="headerText"  />
				<b-row>
					<b-col class="pt-4 pl-4 ml-4">
						<b-form-group class="pl-4 ml-4">
							<b-form-radio-group
								id="typeFilter"
								v-model="typeFilterOptionSelected"
								:options="typeFilterOptions"
								buttons
								button-variant="outline-primary"
								@change="typeFilter('type')"
								size="sm"
								name="radio-btn-outline"
							></b-form-radio-group>
					
						<b-form-radio-group
								class="ml-4"
								id="dateFilter"
								v-model="dateFilterOptionSelected"
								:options="dateFilterOptions"
								buttons
								button-variant="outline-primary"
								@change="typeFilter('date')"
								size="sm"
								name="radio-btn-outline"
						></b-form-radio-group>
						<b-form-radio-group
								class="mx-4"
								id="fullFilmentFilter"
								v-model="fullFilmentFilterOptionSelected"
								:options="fullFilmentFilterOptions"
								buttons
								button-variant="outline-primary"
								@change="typeFilter('fullFilment')"
								size="sm"
								name="radio-btn-outline"
						></b-form-radio-group>
						<b-button class="ml-4 btn-success" size="sm" @click="printAll" v-if="cbxSelected.length >= 1"> Print All Selected Orders</b-button>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col id="mainContainer" class="printHide">
						<v-client-table :data="tableData" :columns="['strOrderId', 'strSalutation', 'slot_date', 'slot_time', 'slot_type',  'locker_id', 'strSecurityPin', 'status', 'fulfilmentStatus', 'strLastSMSStatus', 'manageOrder', 'printOrder', 'select']" :options="options" >
							<span slot="strOrderId" slot-scope="props">
								<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{props.row.strOrderId}}</span>
							</span>
							<span slot="strSalutation" slot-scope="props">
								<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{props.row.strSalutation}}</span>
							</span>
							<span slot="slot_date" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{ props.row.slot_date | moment("DD-MM-YYYY")}}</span>
							</span>	
							<span slot="slot_time" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{ props.row.slot_time }}</span>
							</span>		
							<span slot="slot_type" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{ props.row.slot_type }}</span>
							</span>				
							<span slot="locker_id" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{  props.row.locker_id }}</span>
							</span>				
							<span slot="strSecurityPin" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{ props.row.strSecurityPin }}</span>
							</span>	

							<span slot="status" slot-scope="props">
								<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{props.row.status}}</span>
							</span>

							<span slot="fulfilmentStatus" slot-scope="props">
								<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{props.row.fulfilmentStatus}}</span>
							</span>	

							<span slot="manageOrder" slot-scope="props">
								<b-button variant="outline-success" @click="showFormModal(props.row.id)" class="slotButton" size="sm">Manage</b-button>
							</span>	

							<span slot="strLastSMSStatus" slot-scope="props">
								<span v-if="props.row.strLastSMSStatus == 'success'" :class="props.row.status"> Sent <span class="badge badge-pill badge-success ml-2"> {{props.row.intSMSCount }}</span></span>
								<span v-if="props.row.strLastSMSStatus == 'failed'" :class="props.row.status"> Failed <span class="badge badge-pill badge-danger ml-2"> {{props.row.intSMSCount }}</span></span>
							</span>

							<span slot="printOrder" slot-scope="props">
								<b-button  variant="outline-primary" class="slotButton" size="sm" @click="showPrintModal(props.row.id)">Print</b-button>
							</span>	

							<span slot="select" slot-scope="props" class="text-center">
								<b-form-checkbox
									:id="'cbx' + props.row.id"
									name="cbxSelect"
									:value='props.row.id'
									unchecked-value="false"
									@change="cbxClick"
									>
								</b-form-checkbox>							
							</span>

							<span slot="filter__select" class="text-center d-none">
									<b-form-checkbox
									id="'cbxToogle"
									value='true'
									unchecked-value="false"
									@change="cbxToggle"
									>
								</b-form-checkbox>
							</span>
						
						</v-client-table>
					</b-col>
				</b-row>
			</div>
			<div class="d-md-none">
				<nav-header :navText="headerText"  />
						<v-client-table class="px-1 mobileClientTable" :data="mobileTableData" :columns="['strSalutation', 'slot_date', 'slot_time', 'slot_type', 'manageOrder', 'printOrder']" :options="mobileTableOptions" >
							<span slot="strSalutation" slot-scope="props">
								<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{props.row.strSalutation}}</span>
							</span>
							<span slot="slot_date" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{ props.row.slot_date  | moment("ddd D") }} </span>
							</span>	
							<span slot="slot_time" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >{{ props.row.slot_time }}</span>
							</span>		
							<span slot="slot_type" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" > {{ props.row.slot_type | getSlotTypeIcon }}</span>
							</span>				
							<span slot="props.row.locker_id" slot-scope="props">
									<span :class="[props.row.status, props.row.fulfilmentStatus]" >1</span>
							</span>	
							<span slot="manageOrder" slot-scope="props">
								<b-button variant="outline-success" @click="showFormModal(props.row.id)" class="slotButton" size="sm"><b-icon-eye font-scale="0.7"></b-icon-eye></b-button>
							</span>	
							<span slot="printOrder" slot-scope="props">
								<b-button  variant="outline-primary" class="slotButton" size="sm" @click="showPrintModal(props.row.id)"><b-icon-file-break  font-scale="0.7"></b-icon-file-break></b-button>
							</span>						
						</v-client-table>
			</div>
		</div>
		
		<b-container id="print-all-container-print">

			<div v-for="item in printItems" :key="item.id" class="print-all-container-print">
				<b-row>
					<b-col cols="4" class="border-top border-left">Customer Name:</b-col>							
					<b-col cols="8" class="border-top">{{item.strSalutation}}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Date & Time:</b-col>							
					<b-col cols="8"> {{ item.slot_date  | moment("ddd D MMM") }} @  {{ item.slot_time}}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Order Reference:</b-col>							
					<b-col cols="8">{{ item.strOrderId}}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Transcation Type:</b-col>							
					<b-col cols="8">{{ item.slot_type }}</b-col>							
				</b-row>
				<b-row  v-if="form.slotType == 'locker'">
					<b-col cols="4" class="border-left" >Locker No.:</b-col>							
					<b-col cols="8">{{ item.locker_id}}</b-col>							
				</b-row>
				<b-row  v-if="form.slotType == 'locker'">
					<b-col cols="4" class="border-left" >Secuirty Pin:</b-col>							
					<b-col cols="8">{{ item.strSecurityPin }}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Mobile Tel:</b-col>							
					<b-col cols="8">{{ item.strMobile }}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Message From Store:</b-col>							
					<b-col cols="8">{{ packagingSlipText }}</b-col>							
				</b-row>
				<b-row >
					<b-col cols="4" class="border-left" >Scan with your mobile:</b-col>							
					<b-col cols="8"><img :src="'https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl=http:' + qrcode"/></b-col>							
				</b-row>				
			</div>

		</b-container>
<!-- 		<b-container id="main-print-container-print">
			
			<b-row>
				<b-col cols="4" class="border-top border-left">Customer Name:</b-col>							
				<b-col cols="8" class="border-top">{{this.form.customerName}}</b-col>							
			</b-row>
			<b-row>
				<b-col cols="4" class="border-left" >Date & Time:</b-col>							
				<b-col cols="8"> {{ this.selectedSlotDate  | moment("ddd D MMM") }} @  {{ this.selectedSlotTime}}</b-col>							
			</b-row>
			<b-row>
				<b-col cols="4" class="border-left" >Order Reference:</b-col>							
				<b-col cols="8">{{ this.form.orderId}}</b-col>							
			</b-row>
			<b-row>
				<b-col cols="4" class="border-left" >Transcation Type:</b-col>							
				<b-col cols="8">{{ typeText }}</b-col>							
			</b-row>
			<b-row  v-if="form.slotType == 'locker'">
				<b-col cols="4" class="border-left" >Locker No.:</b-col>							
				<b-col cols="8">{{ this.form.lockerNumber}}</b-col>							
			</b-row>
			<b-row  v-if="form.slotType == 'locker'">
				<b-col cols="4" class="border-left" >Secuirty Pin:</b-col>							
				<b-col cols="8">{{ this.form.securityPin}}</b-col>							
			</b-row>
			<b-row>
				<b-col cols="4" class="border-left" >Mobile Tel:</b-col>							
				<b-col cols="8">{{ this.form.orderMobileNumber}}</b-col>							
			</b-row>
			<b-row v-if="this.$store.state.settings.packagingSlipText.length >= 1">
				<b-col cols="4" class="border-left" >Message From Store:</b-col>							
				<b-col cols="8">{{ packagingSlipText }}</b-col>							
			</b-row>
			<b-row v-if="this.$store.state.settings.packagingSlipPromo === '1'">
				<b-col cols="4" class="border-left" >Scan with your mobile:</b-col>							
				<b-col cols="8"><img :src="'https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl=http:' +  qrcode "/></b-col>							
			</b-row>
			<b-row class="mt-4 pl-3" v-if="form.identifyType != 'none'">
				<b-col>
					<h5>Customer Waiting -  Identification Details</h5>
					<p><strong>Vehicle Registration:</strong> {{ form.identify1}}</p>
					<p><strong>Vehicle Make: </strong> {{ form.identify2}}</p>
					<p><strong>Vehicle Colour:</strong> {{ form.identify3}}</p>
				</b-col>
			</b-row>
			<b-row class="pt-4 printHide">
				<b-button variant="success" @click="printOrderSlip()" class="mr-2">Print</b-button>
				<b-button variant="danger" @click="$bvModal.hide('orderSlipModal')" >Close</b-button>					
			</b-row>				
		</b-container> -->
		
		<b-modal id="orderSlipModal" title="Order Packaging slip" size="lg" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
			<b-container fluid id="main-print-container">
				<b-row>
					<b-col cols="4" class="border-top border-left">Customer Name:</b-col>							
					<b-col cols="8" class="border-top">{{this.form.customerName}}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Date & Time:</b-col>							
					<b-col cols="8"> {{ this.selectedSlotDate  | moment("ddd D MMM") }} @  {{ this.selectedSlotTime}}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Order Reference:</b-col>							
					<b-col cols="8">{{ this.form.orderId}}</b-col>							
				</b-row>
				<b-row>
					<b-col cols="4" class="border-left" >Transaction Type:</b-col>							
					<b-col cols="8">{{ typeText }}</b-col>							
				</b-row>
				<b-row  v-if="form.slotType == 'locker'">
					<b-col cols="4" class="border-left" >Locker No.:</b-col>							
					<b-col cols="8">{{ this.form.lockerNumber}}</b-col>							
				</b-row>
				<b-row  v-if="form.slotType == 'locker'">
					<b-col cols="4" class="border-left" >Security Pin:</b-col>							
					<b-col cols="8">{{ this.form.securityPin}}</b-col>							
				</b-row>
<!--				<b-row>
					<b-col cols="4" class="border-left" >Email:</b-col>							
					<b-col cols="8" class="customerEmail">{{ this.form.orderEmail }}</b-col>							
				</b-row>-->
				<b-row v-if="this.$store.state.settings.packagingSlipText.length >= 1">
					<b-col cols="4" class="border-left" >Mobile Tel:</b-col>							
					<b-col cols="8">{{ this.form.orderMobileNumber}}</b-col>							
				</b-row>
				<b-row v-if="this.$store.state.settings.packagingSlipText.length >= 1">
					<b-col cols="4" class="border-left" >Message From Store:</b-col>							
					<b-col cols="8">{{ this.$store.state.settings.packagingSlipText }}</b-col>							
				</b-row>

				<b-row v-if="this.$store.state.settings.packagingSlipPromo && this.$store.state.settings.qrCodeURL.length >= 4">
					<b-col cols="4" class="border-left" >Scan:</b-col>							
					<b-col cols="8"><img :src="'https://chart.googleapis.com/chart?chs=120x120&cht=qr&chl=http://' +  this.$store.state.settings.qrCodeURL + '&width=130px&height=130px'"/></b-col>							
				</b-row>
				<b-row class="mt-4 pl-3" v-if="form.identifyType != 'none'">
					<b-col>
						<h5>Customer Waiting -  Identification Details</h5>
						<p><strong>Vehicle Registration:</strong> {{ form.identify1}}</p>
						<p><strong>Vehicle Make: </strong> {{ form.identify2}}</p>
						<p><strong>Vehicle Colour:</strong> {{ form.identify3}}</p>
					</b-col>
				</b-row>	
				
				<b-row class="pt-4">
					<b-button variant="success" @click="printOrderSlip()" class="mr-2">Print</b-button>
					<b-button variant="danger" @click="$bvModal.hide('orderSlipModal')" >Close</b-button>					
				</b-row>				
			</b-container>
		</b-modal>
		<b-modal id="formModal" :title="'Manage ' + typeText" hide-footer  no-close-on-esc no-close-on-backdrop>
			<b-row>
				<b-col>
					<b-form class="text-left" validated ref="formContainer">
						<div v-if="!formSubmitted">
						<p><strong> {{ selectedSlotDate |  moment("ddd D MMM")  }} {{ selectedSlotTime }}</strong></p>
						<b-form-group id="customerNameGroup" description="Salutation in SMS message text.">
							<label for="customer-name" class="sr-only">Customer Name</label>
							<b-form-input
							id="customerName"
							v-model="form.customerName"
							required
							:state="customerNameState"
							placeholder="Enter customer name"
							:readonly="modalReadOnly"
							></b-form-input>
							<b-form-invalid-feedback>A customer name is required</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group id="orderMobileNumberGroup" description="The mobile number where the SMS collection details will be sent to.">
							<label for="orderMobileNumber" class="sr-only">Mobile number</label>
							<b-form-input
							id="orderMobileNumber"
							v-model="form.orderMobileNumber"
							:state="orderMobileNumberState"
							type="tel"
							required
							maxlength="11"
							minlength="11"
							trim
							placeholder="Order mobile number"
							:readonly="modalReadOnly"
							></b-form-input>
							<b-form-invalid-feedback>A valid 11 digit UK mobile number is required (starting 07)</b-form-invalid-feedback>
						</b-form-group>
						
				<!--		<b-form-group id="orderEmailGroup" description="">
							<label for="orderEmail" class="sr-only">Email address</label>
							<b-form-input
							id="orderEmail"
							v-model="form.orderEmail"
							:state="orderEmailState"
							type="email"
							required
							placeholder="Order Email"
							></b-form-input>
							<b-form-invalid-feedback>Please enter a valid email address</b-form-invalid-feedback>		
						</b-form-group> -->
						
						<b-form-group id="orderIdGroup" description="">
							<label for="orderId" class="sr-only">Order Id</label>
							<b-form-input
							id="orderId"
							v-model="form.orderId"
							:state="orderIdState"
							type="text"
							required
							placeholder="Order Id"
							:readonly="modalReadOnly"
						></b-form-input>
						<b-form-invalid-feedback>An order id is required</b-form-invalid-feedback>
						<div class="mt-4 pl-3" v-if="form.identifyType != 'none'">
						<h5>Customer Waiting -  Identification Details</h5>
						<p><strong>Vehicle Registration:</strong> {{ form.identify1}}</p>
						<p><strong>Vehicle Make: </strong> {{ form.identify2}}</p>
						<p><strong>Vehicle Colour:</strong> {{ form.identify3}}</p>
						</div>
						</b-form-group>
							<div v-if="showFormButtons">
								<b-button variant="primary" @click="updateOrder()" class="mr-2" :disabled="updateDisabled" v-if="showUpdateButton">Update</b-button>
								<b-button variant="success" @click="confirmResendSMS()" class="mr-2" :disabled="resendDisabled" v-if="showResendButton">Resend Confirmation</b-button>
								<b-button variant="success" @click="confirmFulfilled(form.orderRef)" class="mr-2" v-if="showFulfilledButton">Confirm Recieved by Customer</b-button>
								<b-button  variant="danger" @click="cancelOrder()" class="mr-2 m-1" v-if="showCancelButton">Cancel slot booking</b-button>
								<!--<b-button  variant="danger" @click="closeOrderModal()" class="m-1">Close</b-button>-->
							</div>
						</div>
					</b-form>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>
<script>
import {RepositoryFactory} from '../api/RepositoryFactory'
import NavHeader from './NavHeader'
import {mixin} from '../mixins/clickAndCollectMixins'
const DiaryRepo = RepositoryFactory.get('diary')
const PostDiaryRepo = RepositoryFactory.post('diary')
import moment from 'moment'
export default{
name: 'ClickCollectOrders',
components: {NavHeader},
mixins: [mixin],
	data(){
		return{
			packagingSlipText: this.$store.state.settings.packagingSlipText,
			qrcode: this.$store.state.settings.qrCodeURL,
			cbxSelected: [],
			printItems: [],
			headerText: 'Click&Collect - Manage Orders',			
			tableData: [],
			unfilterdTableData: [],
				options: {
				headings: {
				strOrderId: <b-icon icon='arrow-up-down'></b-icon>, 
				status: <b-icon icon='arrow-up-down'></b-icon>, 
				slot_date: <b-icon icon='arrow-up-down'></b-icon>,
				strSalutation:  <b-icon icon='arrow-up-down'></b-icon>,
				slot_time: "Time",
				slot_type: <b-icon icon='arrow-up-down'></b-icon>,
				locker_id: "Locker",
				strSecurityPin: "Pin",
				manageOrder: "",
				fulfilmentStatus: <b-icon icon='arrow-up-down'></b-icon>,
				strLastSMSStatus: "SMS Status",
				printOrder: ""
				},
				resizableColumns: true,
				sortable: true,
				dateFormat: moment().format(),
				highlightMatches: true,
				orderBy:true,
				perPageValues:[5,10,15,25,50,100],
				perPage:10,
				filterByColumn:true,
				filterable: ['strOrderId', 'strSalutation',  'slot_date', 'slot_type', 'slot_type', 'status', 'fulfilmentStatus'],			
				texts: {
					filter: "Filter:",
					filterBy: "Filter",
				},
				pagination : {edge : false, chunk: 5}
	
			},
			mobileTableData:[],
				mobileTableOptions:{
				headings: {
				slot_date: <b-icon icon="arrow-up-down"></b-icon>,
				strSalutation: <b-icon icon="arrow-up-down"></b-icon>,
				slot_time: '',
				slot_type: <b-icon icon="arrow-up-down"></b-icon>,
				locker_id: "Locker",
				manageOrder: "",
				printOrder: ""
				},
				resizableColumns: true,
				sortable: ['slot_date','strSalutation', 'slot_type'],
				dateFormat: moment().format(),
				highlightMatches: true,
				sortIcon: { base:'glyphicon', up:'glyphicon-chevron-up', down:'glyphicon-chevron-down', is:'glyphicon-sort' },
				orderBy:true,
				perPageValues:[5,10,15,25,50,100],
				perPage:10,
				filterByColumn:true,
				filterable: ['slot_date','strSalutation','slot_type','slot_type'],
				texts: {
					filter: "Filter:",
					filterBy: "Filter {columns}",
				},
				pagination : {edge : false, chunk: 5}
				},
			form: {
				customerName: '',
				orderEmail: '',
				orderMobileNumber: '',
				orderId: '',
				slotId:	'',
				slotType: '',
				slotTime: '',
				orderRef: '',
				securityPin: '',
				storeId: '',
				storeShortName: "",
				orderStatus: "",
				identifyType: "",
				identify1: "",
				identify2: "",
				identify3: "",
				fulfilmentStatus: "",
				},
			typeText: '',
			selectedSlotDay: '',
			selectedSlotDate: '',
			selectedSlotTime: '',
			selectedSlotId: '',
			selectedSlotType: '',
			fullPage: false,
			formSubmitted: false,
			resendDisabled: false,
			updateDisabled: false,
			typeFilterOptionSelected: 'all',
			typeFilterOptions: [
				{	value: 'all', text	: 'All'	}, 
				{	value: 'clickcollect', text	: 'Click&Collect'	},
				{	value: 'locker', text	: 'Locker'	},
				{	value: 'delivery', text	: 'Delivery'	}
			],
			dateFilterOptionSelected: 'all',
			dateFilterOptions: [
				{	value: 'today', text	: 'Today'	},
				{	value: 'week', text	: 'Week'	}
			],
			fullFilmentFilterOptionSelected: null,
			fullFilmentFilterOptions: [
				{	value: 'cancelled', text	: 'Cancelled'	},
				{	value: 'unfullFilled', text	: 'UnFullfilled'	},
				{	value: 'fullfilled', text	: 'Fullfilled'	},			
				{	value: 'waiting', text	: 'Customer Waiting'	}
			
			]
			
		}
	},
	created(){
		this.getAllFutureOrders();
		console.log(this.$store.state.settings)
	},
	methods:{
		cbxToggle(checked = false){
			console.log("toggle checkboxes")
			const cbs = document.querySelectorAll('input[name="cbxSelect"]');
			cbs.forEach((cb) => {
				cb.checked = checked;
			});
			this.cbxSelected = []

		},
		cbxClick()
		{
			this.cbxSelected = [...document.querySelectorAll('input[name=cbxSelect]:checked')].map(e => e.value);
			this.printItems = this.tableData.filter(item =>{
			return this.cbxSelected.includes(item.id)});		
		},
		typeFilter(filter){
			this.tableData = this.unfilterdTableData;
			this.$nextTick().then(() => {	
				if(filter == "type" && this.typeFilterOptionSelected =="all")
				{
					this.fullFilmentFilterOptionSelected = null
					this.dateFilterOptionSelected = 'all'	
				}
				console.log(this.typeFilterOptionSelected)				
				this.$nextTick().then(() => {		
				switch(this.typeFilterOptionSelected)
				{
					case 'locker':
					this.tableData = this.tableData.filter(x=>x.strOrderType == 'locker');
					break;
					case 'clickcollect':
					this.tableData = this.tableData.filter(x=>x.strOrderType == 'clickandcollect');
					break;
					case 'delivery':
					this.tableData = this.tableData.filter(x=>x.strOrderType == 'delivery');
					break;
				//	default:
				//	this.$nextTick().then(() => {	
				//	this.fullFilmentFilterOptionSelected = null
				//	this.dateFilterOptionSelected = 'all'
				//	});
				}				
				this.$nextTick().then(() => {	
					this.dateFilter()
					this.$nextTick().then(() => {	
						this.fullFilmentFilter()
					})
				})
			})
			})			
		},
		dateFilter()
		{
		//	this.fullFilmentFilterOptionSelected = null
		//	this.tableData = this.unfilterdTableData
					this.$nextTick().then(() => {				
				switch(this.dateFilterOptionSelected)
				{
					case 'today':
					this.tableData = this.tableData.filter(x=>x.slot_date == moment().format("YYYY-MM-DD"));
					this.$nextTick().then(() => {	
						switch(this.typeFilterOptionSelected)
						{
							case 'locker':
							this.tableData = this.tableData.filter(x=>x.strOrderType == 'locker');
							break;
							case 'clickcollect':
							this.tableData = this.tableData.filter(x=>x.strOrderType == 'clickandcollect');
							break;
							case 'delivery':
							this.tableData = this.tableData.filter(x=>x.strOrderType == 'delivery');
							break;
					//		case 'all':
					//		this.tableData = this.tableData.filter(x=>x.strOrderType == 'all');			
						}	
					});
					break;
					case 'week':
						console.log(moment().add(6, 'days').format("YYYY-MM-DD"))
					this.tableData = this.tableData.filter(x=>x.slot_date >= moment().format("YYYY-MM-DD"));
					this.$nextTick().then(() => {	
					this.tableData = this.tableData.filter(x=>x.slot_date <= moment().add(7, 'days').format("YYYY-MM-DD"));
							this.$nextTick().then(() => {	
								switch(this.typeFilterOptionSelected)
								{
									case 'locker':
									this.tableData = this.tableData.filter(x=>x.strOrderType == 'locker');
									break;
									case 'clickcollect':
									this.tableData = this.tableData.filter(x=>x.strOrderType == 'clickandcollect');
									break;
									case 'delivery':
									this.tableData = this.tableData.filter(x=>x.strOrderType == 'delivery');
									break;
						//			case 'all':
						//			this.tableData = this.tableData.filter(x=>x.strOrderType == 'all');				
								}	
					});
					});
					break;
				//	default:
				//	this.tableData = this.unfilterdTableData;						
				//	this.typeFilterOptionSelected = 'all'
				}				
					});
			
		},
		fullFilmentFilter()
		{
			this.$nextTick().then(() => {
			
				switch(this.fullFilmentFilterOptionSelected)
				{
					case 'unfullFilled':
					this.tableData = this.tableData.filter(x=>x.status != 'cancelled');
					this.$nextTick().then(() => {	
					this.tableData = this.tableData.filter(x=>x.fulfilmentStatus == 'order received');
					})
					break;
					case 'fullfilled':
					this.tableData = this.tableData.filter(x=>x.fulfilmentStatus == 'order fulfilled');
					break;
					case 'waiting':
					this.tableData = this.tableData.filter(x=>x.fulfilmentStatus == 'customer waiting' || x.fulfilmentStatus == 'customer arrived');
					break;				
					case 'cancelled':
					this.tableData = this.tableData.filter(x=>x.status == 'cancelled');
					break;
										
					
				}	
			});
		},
		atypeFilter(){
			this.fullFilmentFilterOptionSelected = null
			this.dateFilterOptionSelected = 'all'	
			this.$nextTick().then(() => {				
				switch(this.typeFilterOptionSelected)
				{
					case 'locker':
					this.tableData = this.unfilterdTableData.filter(x=>x.strOrderType == 'locker');
					break;
					case 'clickcollect':
					this.tableData = this.unfilterdTableData.filter(x=>x.strOrderType == 'clickandcollect');
					break;
					case 'delivery':
					this.tableData = this.unfilterdTableData.filter(x=>x.strOrderType == 'delivery');
					break;
					default:
					this.tableData = this.unfilterdTableData;
										
					
				}				
					});
			
		},
		getLockerText(lockerId){
			return (lockerId == 1)? lockerId : '';
		},
		printOrder(){
			console.log("Print order")
		},
		updateOrder(){
			this.confirmUpdateResend()
		},
		resendConfirmation(){
			this.postResendConfirmation();
			this.showLoader();	
		},
		async postUpdateOrderField()
		{
			var payload = new FormData();
			payload.append("orderRef", this.form.orderRef)
			payload.append("field", 'fulfilmentStatus')
			payload.append("value", 'order fulfilled')
			
			await PostDiaryRepo.postUpdateOrderField(payload)
		},
		async postUpdateOrder(){
		var payload = new FormData();
		for ( var key in this.form ) {
			payload.append(key, this.form[key]);
		}	
			await PostDiaryRepo.postUpdateOrder(payload)
		},
		async postCancelOrder(){
			var payload = new FormData();		
			for ( var key in this.form ) {
				payload.append(key, this.form[key]);
			}	
			await PostDiaryRepo.postCancelOrder(payload)
		},		
		async getAllFutureOrders(){
			const {data} = await DiaryRepo.getAllFutureOrders(this.$store.state.storeId);
				console.log(data)
				this.tableData = data;
				this.unfilterdTableData = data
				this.mobileTableData = data;
		
		},
		async postResendConfirmation(){
			var payload = new FormData();
			for ( var key in this.form ) {
				payload.append(key, this.form[key]);
			}	
			await PostDiaryRepo.postResendConfirmation(payload)			
		},
		closeOrderModal(){
		this.$bvModal.hide("formModal")
			this.form.orderEmail = ""
			this.form.orderMobileNumber = ""
			this.form.customerName = ""
			this.form.slotId = ""
			this.form.orderId = ""
			this.form.orderRef = ""
			this.form.storeShortName = ""
			this.form.orderStatus = ""
		},
		cancelOrder(){
			this.confirmCancellation()
		},
		printOrderSlip(){
			this.$bvModal.hide("orderSlipModal")
				this.$nextTick().then(() => {
					this.$nextTick().then(() => {
							window.print();
						});
					});
		},
		printAll()
		{
			window.print();
		},
		confirmCancellation() {
        this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this slot booking?', {
			okTitle: 'Yes',
			cancelTitle: 'No',
		})
          .then(value => {
			if(value){			
				this.postCancelOrder();
				this.showLoader();
			}
          })
		},
		confirmUpdateResend() {
        this.$bvModal.msgBoxConfirm('Do you want to resend the SMS notification?', {
			okTitle: 'Update and Resend SMS',
			cancelTitle: 'Update Only',
		})
          .then(value => {
			this.postUpdateOrder();
			this.showLoader();	
			if(value){			
				this.postResendConfirmation()
			}
          })
		},
		confirmFulfilled()
		{
			this.$bvModal.msgBoxConfirm('Has customer received the order', {
				okTitle: 'Yes',
				cancelTitle: 'No',
			})
			.then(value => {	
				if(value){					
				this.showLoader();	
				
				this.postUpdateOrderField()
				}
			})
		},
		confirmResendSMS() {
        this.$bvModal.msgBoxConfirm('Do you want to resend the SMS notification?', {
			okTitle: 'Yes Resend SMS',
			cancelTitle: 'No',
		})
          .then(value => {
			if(value){			
				this.resendConfirmation()
			}
          })
		},
		showPrintModal(orderId){
			this.cbxToggle();
			this.setFormData(orderId);
			this.$bvModal.show("orderSlipModal")
			this.printItems = this.tableData.filter(item =>{
			return item.id == orderId});
			
		},
		showFormModal(orderId){
			this.setFormData(orderId)
			this.$bvModal.show("formModal")
		},
		setFormData(orderId){
			let order = this.tableData.filter(item => item.id == orderId);
			switch(order[0].slot_type)
			{
				case 'locker':
				this.typeText = 'Locker Booking';
				break;
				case 'clickandcollect':
				this.typeText = 'Click and Collect Booking';
				break;
				case 'delivery':
				this.typeText = 'Delivery';
				break
			}
			
			this.selectedSlotDate = order[0].slot_date
			this.selectedSlotTime = order[0].slot_time
			this.selectedSlotType = order[0].slot_type
			this.form.slotType = order[0].slot_type
			this.form.slotDate = order[0].slot_date
			this.form.slotTime = order[0].slot_time
			this.form.slotId = order[0].slot_id
			this.form.orderRef = order[0].order_ref
			this.form.customerName = order[0].strSalutation
			this.form.orderEmail = order[0].strEmail
			this.form.orderMobileNumber = order[0].strMobile
			this.form.orderId = order[0].strOrderId
			this.form.securityPin = order[0].strSecurityPin
			this.form.lockerNumber = order[0].locker_id
			this.form.storeShortName = this.$store.state.settings.storeShortName
			this.form.storeId = this.$store.state.storeId
			this.form.orderStatus = order[0].status
			this.form.identifyType = order[0].identifyType
			this.form.identify1 = order[0].identify1
			this.form.identify2 = order[0].identify2
			this.form.identify3 = order[0].identify3
			this.form.fulfilmentStatus = order[0].fulfilmentStatus
		},
		showLoader(){
			this.formSubmitted = true
			let loader = this.$loading.show({
			container: this.fullPage ? null : this.$refs.formContainer,
			canCancel: false,
			onCancel: this.onCancel,
			loader: 'dots',
			color: 'green',
			opacity: 0.5,
			});
			
			this.$nextTick().then(() => {
				setTimeout(() => {
				loader.hide()	
				this.closeOrderModal()
				this.getAllFutureOrders();
				this.formSubmitted = false				
			}, 1500)
			});			
		}
	},
	computed:{
		showFormButtons: function(){
			return (this.form.orderStatus != "cancelled")? true : false
		},
		customerNameState(){
			if(this.form.orderStatus == "cancelled"   || this.form.fulfilmentStatus == "order fulfilled")
			{
			
				return null
			}
			else
			{
				return this.form.customerName.length >= 2 ? true : false;
			}
			
		},
		orderMobileNumberState: {
			get: function () {
				let isValid = true
				let mNumber = this.form.orderMobileNumber
				let starts07 = mNumber.substring(0,2)
				if(mNumber.length != 11 || starts07 != "07")
				{
					isValid = false
				}		
				if(this.form.orderStatus == "cancelled"   || this.form.fulfilmentStatus == "order fulfilled")
				{
				
					return null
				}
				else
				{
					return isValid
				}
			}		
		},
		orderEmailState(){
			return this.form.orderEmail.length == "derekmwanza@hotmail.co.uk" ? true: false; 
		},
		orderIdState(){
			if(this.form.orderStatus == "cancelled"   || this.form.fulfilmentStatus == "order fulfilled")
			{
				return null
			}
			else
			{
				return this.form.orderId.length >= 2? true : false;
			}
		},
		showFulfilledButton: function()
		{
			return  (this.form.fulfilmentStatus == "customer arrived" || this.form.fulfilmentStatus == "customer waiting")? true : false
		},
		showResendButton: function()
		{
			return (this.$store.state.settings.resendSMS == true && this.form.fulfilmentStatus == "order received")? true : false
		},
		showCancelButton: function()
		{
			return (this.form.fulfilmentStatus == "customer arrived" || this.form.fulfilmentStatus == "customer waiting" || this.form.fulfilmentStatus == "order fulfilled")? false : true
		},
		showUpdateButton: function()
		{
			return (this.form.fulfilmentStatus == "order fulfilled")? false : true
		},
		modalReadOnly: function(){
			return (this.form.orderStatus == "cancelled" || this.form.fulfilmentStatus == "order fulfilled")? true : false
			
		}
	},
	watch:{
		orderMobileNumberState(newVal){		

			return (!newVal)? this.resendDisabled = true: this.resendDisabled = false;
		}
	},
	mounted(){
	
	}
}
</script>
<style>

	.customerEmail{
		word-wrap: break-word;
	}

	.mobileClientTable
	{
		margin: 0px auto;
		width: 98%;
	}

	#main-print-container .row{
		width: 100%
	}

	#main-print-container .col-4, #main-print-container .col-8{
		border-bottom: 1px solid #c0c0c0;
		border-right: 1px solid #c0c0c0;
		padding: 10px;
	}

	#mainContainer > div > div.table-responsive > table > thead > tr:nth-child(1) > th:nth-child(1) {width: 150px}

	#main-print-container-print, #print-all-container-print{
		display: none;
	}
	#main-print-container {

		margin: 10px auto;
	}

	.table th, .table td{
		vertical-align: middle !important; 
	}
	input::placeholder{
		font-size: 0.8em !important;
	} 
	#mainContainer{
		padding: 0px 100px;
	}
	.cancelled{
		color: red
	}
	
	.confirmed.customer.waiting
	{
		color: #008e00;
	}
	
	.confirmed.customer.arrived
	{
		color: #ffbe07;
	}
	
	.VueTables__limit-field{
	display: none;
	}

	.btn-lg {
		padding: 18px 28px;
		font-size: 22px;
		border-radius: 8px;
	}

	.orderDetailItem, .orderDetailText, .orderDetailNotes, .orderDetailNotesText  {
		float: left;
		margin: 0 3px 3px 3px; 
		padding: 0.4em; 
		padding-left: 1.5em; 
		font-size: 1.2em; 
		height: 18px; 
		border: 1px solid #c0c0c0;
	}

	.orderDetailItem, .orderDetailNotes {
		width: 30%;
		font-weight: bold;
	}

	.orderDetailNotes, .orderDetailNotesText {
		height: 130px;
	}
 
	.orderDetailNotes {
		padding: 0.3em; padding-left: 1.6em
	}
   
   .orderDetailNotesText {
		font-size: 1em; 
		width: 50.5%;
	}
   
	.orderDetailText {
	width: 50%
	}
   
	.description {
		height: 90px
	}

	#addressDetails {
		clear: both
	}

	hr{
		border: 1px dashed black;
	}
	
	#app > div > div.printHide > div.md-d-none > div.VueTables.VueTables--client > div.table-responsive > table > tbody
	{
	font-size: x-small
	}
	
	@media print {
		.printHide{
			display: none !important;
		}
		#main-print-container-print .row{			
			width: 100%;
		}

		#main-print-container-print .col-4, #main-print-container-print .col-8,
		.print-all-container-print .border-left.col-4, .print-all-container-print .col-8 
		{
			border-bottom: 1px solid #c0c0c0;
			border-right: 1px solid #c0c0c0;
			padding: 20px;
		}

		#main-print-container-print{
			margin: 20px auto;
		}

		#main-print-container-print, .print-all-container-print{
			margin-top: 300px;
			font-size: 1.5em;
		}

		
		#main-print-container-print, #print-all-container-print{
			display: block;
		}


		.print-all-container-print
		{
			page-break-after: always;
		}
	}
  </style>
